module.exports = __webpack_public_path__ + "img/vertical_2_1_8019.13076e53.png";